const SUFFIX_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const PRODUCT_TYPES = [
  "shampoo", "conditioner", "cleanser", "moisturizer", "treatment", "detangler",
  "pomade", "styling", "styler", "serum", "lotion", "cream", "gel", "oil",
  "spray", "mask", "balm", "wax", "toner", "mousse", "soap",
];

const letters = (value) => String(value || "").replace(/[^a-z]/gi, "");
const paddedCode = (value, fallback) => `${String(value || "").toUpperCase()}${fallback}`.slice(0, 3);

export function extractSkuBrand(vendorName) {
  return paddedCode(letters(vendorName).slice(0, 3), "UNK");
}

export function extractSkuSize(productName) {
  const match = String(productName || "").match(/\b(\d+(?:\.\d+)?)\s*(?:fl\.?\s*)?(oz|ml|lb|lbs|kg|g|l)\b/i);
  if (!match) return "";
  const unit = match[2].toLowerCase();
  const unitCode = unit === "oz" ? "O" : unit === "ml" ? "M" : unit === "lbs" ? "L" : unit.slice(0, 1).toUpperCase();
  return `${match[1]}${unitCode}`;
}

export function extractSkuProductType(productName) {
  const words = String(productName || "").match(/[a-z]+/gi) || [];
  const usableWords = words.filter((word) => !["oz", "ml", "lb", "lbs", "kg", "g", "l", "fl"].includes(word.toLowerCase()));
  const type = [...usableWords].reverse().find((word) => PRODUCT_TYPES.includes(word.toLowerCase())) || usableWords.at(-1) || "";
  return paddedCode(type.slice(0, 3), "PRD");
}

export function randomSkuSuffix(random = Math.random) {
  return Array.from({ length: 4 }, () => SUFFIX_ALPHABET[Math.floor(random() * SUFFIX_ALPHABET.length)]).join("");
}

export function generateProductSku(productName, vendorName, random) {
  if (!String(productName || "").trim()) return "";
  return `MP${extractSkuBrand(vendorName)}${extractSkuSize(productName)}${extractSkuProductType(productName)}-${randomSkuSuffix(random)}`;
}